import api, { TOKEN_KEY, setToken } from './api';

export const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
};

export async function postAutentication(usuario, senha) {
    const response = await api.post('/login', {
        usuario,
        senha,
    });
    setToken(response.accessToken);
    return response;
}
